import classNames from "classnames";
import styles from "./VoiceRecorder.module.css";
import React, { useImperativeHandle, forwardRef, useEffect, useState } from "react";
import { useVoiceVisualizer, VoiceVisualizer } from "react-voice-visualizer";
import { styleTypeProps } from "./VoiceRecorderStyles";
import { setConvertedBlob } from "./utils";
import ProgressOverlay from "Components/progressOverlay";
const VoiceRecorder = forwardRef(({ className, styleType = "primary", width = "100%", height = 200, onFileChange, startRecordingOnInit, maxRecordingTime, outputFormat, fileName = "record", ...useVoiceVisualizerProps }, ref) => {
    const recorderControls = useVoiceVisualizer({ ...useVoiceVisualizerProps });
    const { isProcessingOnResize, recordedBlob, error, recordingTime, stopRecording, startRecording, stopAudioPlayback, startAudioPlayback } = recorderControls;
    const [showProgress, setShowProgress] = useState(false);
    const togglePauseResume = () => {
        if (isProcessingOnResize) {
            stopRecording();
        }
        else {
            startRecording();
        }
    };
    const onCLick = () => {
        stopAudioPlayback();
    };
    const onDoubleClick = () => {
        startAudioPlayback();
    };
    useEffect(() => {
        if (onFileChange) {
            setConvertedBlob(recordedBlob, onFileChange, outputFormat, fileName);
        }
    }, [recordedBlob]);
    useEffect(() => {
        if (!error)
            return;
        console.error(error);
    }, [error]);
    useEffect(() => {
        if (maxRecordingTime && recordingTime + 1000 >= maxRecordingTime) {
            stopRecording();
        }
    }, [maxRecordingTime, recordingTime]);
    useEffect(() => {
        if (startRecordingOnInit) {
            startRecording();
        }
    }, []);
    useImperativeHandle(ref, () => ({
        togglePauseResume,
        stopRecording,
        startRecording,
        setShowProgress
    }), [stopRecording, startRecording, setShowProgress]);
    return (React.createElement("div", { className: classNames(styles.container, className), onDoubleClick: onDoubleClick, onClick: onCLick },
        React.createElement(ProgressOverlay, { show: showProgress },
            React.createElement(VoiceVisualizer, { controls: recorderControls, ...styleTypeProps[styleType], width: width, height: height, isControlPanelShown: false, isDownloadAudioButtonShown: false, isAudioProcessingTextShown: false, isProgressIndicatorTimeShown: false, isProgressIndicatorShown: false, isProgressIndicatorOnHoverShown: false, isProgressIndicatorTimeOnHoverShown: false, isDefaultUIShown: !startRecordingOnInit, fullscreen: true }))));
});
VoiceRecorder.displayName = "VoiceRecorder";
export default VoiceRecorder;
